import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FaShoppingCart, FaBars, FaTimes, FaSearch, FaStore, FaUserCircle, FaSignOutAlt } from "react-icons/fa";
import { useCart } from "../../hooks/useCart";
import { useAuth } from "../../hooks/useAuth";
import { useToastContext } from "../../context/ToastContext";
import styles from "./Navbar.module.css";

const NAV_LINKS = [
  { to: "/", label: "首頁" },
  { to: "/products", label: "所有商品" },
  { to: "/orders", label: "訂單紀錄" },
];

function Navbar() {
  const { totalCount } = useCart();
  const { member, logout, isLoggedIn } = useAuth();
  const { addToast } = useToastContext();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  function handleSearch(e) {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/products?search=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery("");
      setMenuOpen(false);
    }
  }

  function handleLogout() {
    logout();
    addToast("已登出", "info");
    navigate("/");
  }

  return (
    <header className={styles.header}>
      <nav className={styles.nav}>
        <Link to="/" className={styles.logo} aria-label="回首頁">
          <FaStore className={styles.logoIcon} />
          <span>沃克貓購物網</span>
        </Link>

        <div className={styles.links}>
          {NAV_LINKS.map(link => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles.active : ""}`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </div>

        <form className={styles.searchForm} onSubmit={handleSearch}>
          <input
            type="search"
            placeholder="搜尋商品..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            className={styles.searchInput}
            aria-label="搜尋商品"
          />
          <button type="submit" className={styles.searchBtn} aria-label="搜尋">
            <FaSearch />
          </button>
        </form>

        <div className={styles.actions}>
          {isLoggedIn ? (
            <div className={styles.memberGroup}>
              <span className={styles.memberName}>
                <FaUserCircle className={styles.memberIcon} />
                {member.name}
              </span>
              <button
                onClick={handleLogout}
                className={styles.logoutBtn}
                aria-label="登出"
              >
                <FaSignOutAlt />
              </button>
            </div>
          ) : (
            <Link to="/login" className={styles.loginBtn} aria-label="會員登入">
              <FaUserCircle />
              <span>登入</span>
            </Link>
          )}

          <Link to="/cart" className={styles.cartBtn} aria-label={`購物車，${totalCount} 件商品`}>
            <FaShoppingCart className={styles.cartIcon} />
            {totalCount > 0 && (
              <span className={styles.badge}>{totalCount > 99 ? "99+" : totalCount}</span>
            )}
          </Link>

          <button
            className={styles.menuBtn}
            onClick={() => setMenuOpen(v => !v)}
            aria-label={menuOpen ? "關閉選單" : "開啟選單"}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className={styles.mobileMenu}>
          <form className={styles.mobileSearch} onSubmit={handleSearch}>
            <input
              type="search"
              placeholder="搜尋商品..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              className={styles.searchInput}
              aria-label="搜尋商品（手機）"
            />
            <button type="submit" className={styles.searchBtn} aria-label="搜尋">
              <FaSearch />
            </button>
          </form>

          {NAV_LINKS.map(link => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                `${styles.mobileLink} ${isActive ? styles.active : ""}`
              }
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </NavLink>
          ))}

          {isLoggedIn ? (
            <button
              onClick={() => { handleLogout(); setMenuOpen(false); }}
              className={`${styles.mobileLink} ${styles.mobileLinkDanger}`}
            >
              <FaSignOutAlt /> 登出（{member.name}）
            </button>
          ) : (
            <NavLink
              to="/login"
              className={({ isActive }) =>
                `${styles.mobileLink} ${isActive ? styles.active : ""}`
              }
              onClick={() => setMenuOpen(false)}
            >
              <FaUserCircle /> 會員登入
            </NavLink>
          )}
        </div>
      )}
    </header>
  );
}

export default Navbar;
